// extracted by mini-css-extract-plugin
export default {"card-open-button":"CardOpenButton_card-open-button__cIYYF"};